import {createAction} from 'redux-actions';

/*COMMON*/
export const CHANGE_SCREEN_SIZE = 'CHANGE_SCREEN_SIZE';
export const changeScreenSize = createAction(CHANGE_SCREEN_SIZE);

export const RESET_PROCESS_ERROR = 'RESET_PROCESS_ERROR';
export const resetProcessError = createAction(RESET_PROCESS_ERROR);

/*NAVIGATION*/
export const CHANGE_CURRENT_PATH = 'CHANGE_CURRENT_PATH';
export const changeCurrentPath = createAction(CHANGE_CURRENT_PATH);
export const CHANGE_NEXT_PATH = 'CHANGE_NEXT_PATH';
export const changeNextPath = createAction(CHANGE_NEXT_PATH);

/*DOCUMENTS*/
export const CLICK_SHOW_MANUALS = 'CLICK_SHOW_MANUALS';
export const clickShowManuals = createAction(CLICK_SHOW_MANUALS);
export const CLICK_CLOSE_MANUALS = 'CLICK_CLOSE_MANUALS';
export const clickCloseManuals = createAction(CLICK_CLOSE_MANUALS);
export const SHOW_MANUALS = 'SHOW_MANUALS';
export const showManuals = createAction(SHOW_MANUALS);
export const FAIL_SHOW_MANUALS = 'FAIL_SHOW_MANUALS';
export const failShowManuals = createAction(FAIL_SHOW_MANUALS);
export const CLICK_SHOW_TERMS = 'CLICK_SHOW_TERMS';
export const clickShowTerms = createAction(CLICK_SHOW_TERMS);
export const CLICK_CLOSE_TERMS = 'CLICK_CLOSE_TERMS';
export const clickCloseTerms = createAction(CLICK_CLOSE_TERMS);
export const SHOW_TERMS = 'SHOW_TERMS';
export const showTerms = createAction(SHOW_TERMS);
export const FAIL_SHOW_TERMS = 'FAIL_SHOW_TERMS';
export const failShowTerms = createAction(FAIL_SHOW_TERMS);
export const CLICK_SHOW_POLICY = 'CLICK_SHOW_POLICY';
export const clickShowPolicy = createAction(CLICK_SHOW_POLICY);
export const CLICK_CLOSE_POLICY = 'CLICK_CLOSE_POLICY';
export const clickClosePolicy = createAction(CLICK_CLOSE_POLICY);
export const SHOW_POLICY = 'SHOW_POLICY';
export const showPolicy = createAction(SHOW_POLICY);
export const FAIL_SHOW_POLICY = 'FAIL_SHOW_POLICY';
export const failShowPolicy = createAction(FAIL_SHOW_POLICY);

/*LOGIN AUTH*/
export const FETCH_USER = 'FETCH_USER';
export const fetchUser = createAction(FETCH_USER);
export const FAIL_FETCH_USER = 'FAIL_FETCH_USER';
export const failFetchUser = createAction(FAIL_FETCH_USER);

export const LOGIN = 'LOGIN';
export const login = createAction(LOGIN);
export const LOGOUT = 'LOGOUT';
export const logout = createAction(LOGOUT);
export const CLICK_LOGOUT = 'CLICK_LOGOUT';
export const clickLogout = createAction(CLICK_LOGOUT);

export const CLICK_AGREE_TERMS = 'CLICK_AGREE_TERMS';
export const clickAgreeTerms = createAction(CLICK_AGREE_TERMS);
export const AGREE_TERMS = 'AGREE_TERMS';
export const agreeTerms = createAction(AGREE_TERMS);

export const SEND_RESET_PASSWORD = 'SEND_RESET_PASSWORD';
export const sendResetPassword = createAction(SEND_RESET_PASSWORD);
export const FAIL_SEND_RESET_PASSWORD = 'FAIL_SEND_RESET_PASSWORD';
export const failSendResetPassword = createAction(FAIL_SEND_RESET_PASSWORD);
export const SUCCESS_SEND_RESET_PASSWORD = 'SUCCESS_SEND_RESET_PASSWORD';
export const successSendResetPassword = createAction(SUCCESS_SEND_RESET_PASSWORD);
export const COMPLETE_RESET_PASSWORD = 'COMPLETE_RESET_PASSWORD'
export const completeResetPassword = createAction(COMPLETE_RESET_PASSWORD);


/*UPLOAD*/
export const START_UPLOAD_PROCESS = 'START_UPLOAD_PROCESS';
export const startUploadProcess = createAction(START_UPLOAD_PROCESS);
export const UPLOAD_DATA = 'UPLOAD_DATA';
export const uploadData = createAction(UPLOAD_DATA);
export const FAIL_UPLOAD_DATA = 'FAIL_UPLOAD_DATA';
export const failUploadData = createAction(FAIL_UPLOAD_DATA);
export const SUCCESS_UPLOAD_DATA = 'SUCCESS_UPLOAD_DATA';
export const successUploadData = createAction(SUCCESS_UPLOAD_DATA);
export const SET_UPLOAD_LIST = 'SET_UPLOAD_LIST';
export const setUploadList = createAction(SET_UPLOAD_LIST);
export const DELETE_UPLOAD_LIST = 'DELETE_UPLOAD_LIST';
export const deleteUploadList = createAction(DELETE_UPLOAD_LIST);
export const SAVE_UPLOAD_CSV = 'SAVE_UPLOAD_CSV';
export const saveUploadCsv = createAction(SAVE_UPLOAD_CSV);
export const FAIL_SAVE_UPLOAD_CSV = 'FAIL_SAVE_UPLOAD_CSV';
export const failSaveUploadCsv = createAction(FAIL_SAVE_UPLOAD_CSV);
export const SUCCESS_SAVE_UPLOAD_CSV = 'SUCCESS_SAVE_UPLOAD_CSV';
export const successSaveUploadCsv = createAction(SUCCESS_SAVE_UPLOAD_CSV);
export const RESET_UPLOAD_STATE = 'RESET_UPLOAD_STATE';
export const resetUploadState = createAction(RESET_UPLOAD_STATE);

export const GET_CSV_TEMPLATE = 'GET_CSV_TEMPLATE';
export const getCsvTemplate = createAction(GET_CSV_TEMPLATE);
export const FAIL_GET_CSV_TEMPLATE = 'FAIL_GET_CSV_TEMPLATE';
export const failGetCsvTemplate = createAction(FAIL_GET_CSV_TEMPLATE);
export const SUCCESS_GET_CSV_TEMPLATE = 'SUCCESS_GET_CSV_TEMPLATE';
export const successGetCsvTemplate = createAction(SUCCESS_GET_CSV_TEMPLATE);


export const FETCH_CSV_TEMPLATE_INFO = 'FETCH_CSV_TEMPLATE_INFO';
export const fetchCsvTemplateInfo = createAction(FETCH_CSV_TEMPLATE_INFO);
export const FAIL_FETCH_CSV_TEMPLATE_INFO = 'FAIL_FETCH_CSV_TEMPLATE_INFO';
export const failFetchCsvTemplateInfo = createAction(FAIL_FETCH_CSV_TEMPLATE_INFO);
export const SUCCESS_FETCH_CSV_TEMPLATE_INFO = 'SUCCESS_FETCH_CSV_TEMPLATE_INFO';
export const successFetchCsvTemplateInfo = createAction(SUCCESS_FETCH_CSV_TEMPLATE_INFO);


/*MAIN LIST*/
export const FETCH_MAIN_LIST = 'FETCH_MAIN_LIST';
export const fetchMainList = createAction(FETCH_MAIN_LIST);
export const FAIL_FETCH_MAIN_LIST = 'FAIL_FETCH_MAIN_LIST';
export const failFetchMainList = createAction(FAIL_FETCH_MAIN_LIST);
export const SET_MAIN_LIST_DATA = 'SET_MAIN_LIST_DATA';
export const setMainListData = createAction(SET_MAIN_LIST_DATA);

export const SET_MAIN_LIST_STATE = 'SET_MAIN_LIST_STATE';
export const setMainListState = createAction(SET_MAIN_LIST_STATE);

export const RESET_MAIN_LIST_STATE = 'RESET_MAIN_LIST_STATE';
export const resetMainListState = createAction(RESET_MAIN_LIST_STATE);

/*DETAIL LIST*/
export const SET_MAIN_LIST_SELECTIONS = 'SET_MAIN_LIST_SELECTIONS';
export const setMainListSelections = createAction(SET_MAIN_LIST_SELECTIONS);

export const FETCH_DETAIL_LIST = 'FETCH_DETAIL_LIST';
export const fetchDetailList = createAction(FETCH_DETAIL_LIST);
export const FAIL_FETCH_DETAIL_LIST = 'FAIL_FETCH_DETAIL_LIST';
export const failFetchDetailList = createAction(FAIL_FETCH_DETAIL_LIST);
export const SET_DETAIL_LIST_DATA = 'SET_DETAIL_LIST_DATA';
export const setDetailListData = createAction(SET_DETAIL_LIST_DATA);
export const RESET_DETAIL_LIST_STATE = 'RESET_DETAIL_LIST_STATE';
export const resetDetailListState = createAction(RESET_DETAIL_LIST_STATE);

/*CONSIGNEE LIST*/
export const FETCH_CONSIGNEE_LIST = 'FETCH_CONSIGNEE_LIST';
export const fetchConsigneeList = createAction(FETCH_CONSIGNEE_LIST);
export const FAIL_FETCH_CONSIGNEE_LIST = 'FAIL_FETCH_CONSIGNEE_LIST';
export const failFetchConsigneeList = createAction(FAIL_FETCH_CONSIGNEE_LIST);
export const SET_CONSIGNEE_LIST_DATA = 'SET_CONSIGNEE_LIST_DATA';
export const setConsigneeListData = createAction(SET_CONSIGNEE_LIST_DATA);

export const RESET_CONSIGNEE_LIST_STATE = 'RESET_CONSIGNEE_LIST_STATE';
export const resetConsigneeListState = createAction(RESET_CONSIGNEE_LIST_STATE);

export const UPDATE_CONSIGNEE_FLAG = 'UPDATE_CONSIGNEE_FLAG';
export const updateConsigneeFlag = createAction(UPDATE_CONSIGNEE_FLAG);
export const FAIL_UPDATE_CONSIGNEE_FLAG = 'FAIL_UPDATE_CONSIGNEE_FLAG';
export const failUpdateConsigneeFlag = createAction(FAIL_UPDATE_CONSIGNEE_FLAG);
export const SUCCESS_UPDATE_CONSIGNEE_FLAG = 'SUCCESS_UPDATE_CONSIGNEE_FLAG';
export const successUpdateConsigneeFlag = createAction(SUCCESS_UPDATE_CONSIGNEE_FLAG);

export const UNDO_CONSIGNEE_FLAG = 'UNDO_CONSIGNEE_FLAG';
export const undoConsigneeFlag = createAction(UNDO_CONSIGNEE_FLAG);
export const FAIL_UNDO_CONSIGNEE_FLAG = 'FAIL_UNDO_CONSIGNEE_FLAG';
export const failUndoConsigneeFlag = createAction(FAIL_UNDO_CONSIGNEE_FLAG);
export const SUCCESS_UNDO_CONSIGNEE_FLAG = 'SUCCESS_UNDO_CONSIGNEE_FLAG';
export const successUndoConsigneeFlag = createAction(SUCCESS_UNDO_CONSIGNEE_FLAG);


export const GET_PDF_ITEMS_CONSIGNEE = 'GET_PDF_ITEMS_CONSIGNEE';
export const getPdfItemsConsignee = createAction(GET_PDF_ITEMS_CONSIGNEE);
export const FAIL_GET_PDF_ITEMS_CONSIGNEE = 'FAIL_GET_PDF_ITEMS_CONSIGNEE';
export const failGetPdfItemsConsignee = createAction(FAIL_GET_PDF_ITEMS_CONSIGNEE);
export const SET_PDF_ITEMS_CONSIGNEE = 'SET_PDF_ITEMS_CONSIGNEE';
export const setPdfItemsConsignee = createAction(SET_PDF_ITEMS_CONSIGNEE);
export const CLEAR_PDF_ITEMS_CONSIGNEE = 'CLEAR_PDF_ITEMS_CONSIGNEE';
export const clearPdfItemsConsignee = createAction(CLEAR_PDF_ITEMS_CONSIGNEE);


/*CONSIGNEE LIST NEW*/
export const FETCH_CONSIGNEE_LIST_NEW = 'FETCH_CONSIGNEE_LIST_NEW';
export const fetchConsigneeListNew = createAction(FETCH_CONSIGNEE_LIST_NEW);
export const FAIL_FETCH_CONSIGNEE_LIST_NEW = 'FAIL_FETCH_CONSIGNEE_LIST_NEW';
export const failFetchConsigneeListNew = createAction(FAIL_FETCH_CONSIGNEE_LIST_NEW);
export const SET_CONSIGNEE_LIST_DATA_NEW = 'SET_CONSIGNEE_LIST_DATA_NEW';
export const setConsigneeListDataNew = createAction(SET_CONSIGNEE_LIST_DATA_NEW);

export const RESET_CONSIGNEE_LIST_STATE_NEW = 'RESET_CONSIGNEE_LIST_STATE_NEW';
export const resetConsigneeListStateNew = createAction(RESET_CONSIGNEE_LIST_STATE_NEW);

export const UPDATE_CONSIGNEE_FLAG_NEW = 'UPDATE_CONSIGNEE_FLAG_NEW';
export const updateConsigneeFlagNew = createAction(UPDATE_CONSIGNEE_FLAG_NEW);
export const FAIL_UPDATE_CONSIGNEE_FLAG_NEW = 'FAIL_UPDATE_CONSIGNEE_FLAG_NEW';
export const failUpdateConsigneeFlagNew = createAction(FAIL_UPDATE_CONSIGNEE_FLAG_NEW);
export const SUCCESS_UPDATE_CONSIGNEE_FLAG_NEW = 'SUCCESS_UPDATE_CONSIGNEE_FLAG_NEW';
export const successUpdateConsigneeFlagNew = createAction(SUCCESS_UPDATE_CONSIGNEE_FLAG_NEW);

export const UNDO_CONSIGNEE_FLAG_NEW = 'UNDO_CONSIGNEE_FLAG_NEW';
export const undoConsigneeFlagNew = createAction(UNDO_CONSIGNEE_FLAG_NEW);
export const FAIL_UNDO_CONSIGNEE_FLAG_NEW = 'FAIL_UNDO_CONSIGNEE_FLAG_NEW';
export const failUndoConsigneeFlagNew = createAction(FAIL_UNDO_CONSIGNEE_FLAG_NEW);
export const SUCCESS_UNDO_CONSIGNEE_FLAG_NEW = 'SUCCESS_UNDO_CONSIGNEE_FLAG_NEW';
export const successUndoConsigneeFlagNew = createAction(SUCCESS_UNDO_CONSIGNEE_FLAG_NEW);


export const GET_PDF_ITEMS_CONSIGNEE_NEW = 'GET_PDF_ITEMS_CONSIGNEE_NEW';
export const getPdfItemsConsigneeNew = createAction(GET_PDF_ITEMS_CONSIGNEE_NEW);
export const FAIL_GET_PDF_ITEMS_CONSIGNEE_NEW = 'FAIL_GET_PDF_ITEMS_CONSIGNEE_NEW';
export const failGetPdfItemsConsigneeNew = createAction(FAIL_GET_PDF_ITEMS_CONSIGNEE_NEW);
export const SET_PDF_ITEMS_CONSIGNEE_NEW = 'SET_PDF_ITEMS_CONSIGNEE_NEW';
export const setPdfItemsConsigneeNew = createAction(SET_PDF_ITEMS_CONSIGNEE_NEW);
export const CLEAR_PDF_ITEMS_CONSIGNEE_NEW = 'CLEAR_PDF_ITEMS_CONSIGNEE_NEW';
export const clearPdfItemsConsigneeNew = createAction(CLEAR_PDF_ITEMS_CONSIGNEE_NEW);

export const SET_CONSIGNEE_LIST_NEW_STATE = 'SET_CONSIGNEE_LIST_NEW_STATE';
export const setConsigneeListNewState = createAction(SET_CONSIGNEE_LIST_NEW_STATE);

export const GET_PDF_ITEMS_CONSIGNEE_MOD = 'GET_PDF_ITEMS_CONSIGNEE_MOD';
export const getPdfItemsConsigneeMod = createAction(GET_PDF_ITEMS_CONSIGNEE_MOD);
export const FAIL_GET_PDF_ITEMS_CONSIGNEE_MOD = 'FAIL_GET_PDF_ITEMS_CONSIGNEE_MOD';
export const failGetPdfItemsConsigneeMod = createAction(FAIL_GET_PDF_ITEMS_CONSIGNEE_MOD);
export const SET_PDF_ITEMS_CONSIGNEE_MOD = 'SET_PDF_ITEMS_CONSIGNEE_MOD';
export const setPdfItemsConsigneeMod = createAction(SET_PDF_ITEMS_CONSIGNEE_MOD);
export const CLEAR_PDF_ITEMS_CONSIGNEE_MOD = 'CLEAR_PDF_ITEMS_CONSIGNEE_MOD';
export const clearPdfItemsConsigneeMod = createAction(CLEAR_PDF_ITEMS_CONSIGNEE_MOD);


/*RECEIPT LIST*/
export const SET_RECEIPT_LIST_STATE = 'SET_RECEIPT_LIST_STATE';
export const setReceiptListState = createAction(SET_RECEIPT_LIST_STATE);
export const RESET_RECEIPT_LIST_STATE = 'RESET_RECEIPT_LIST_STATE';
export const resetReceiptListState = createAction(RESET_RECEIPT_LIST_STATE);


export const FETCH_RECEIPT_LIST = 'FETCH_RECEIPT_LIST';
export const fetchReceiptList = createAction(FETCH_RECEIPT_LIST);
export const FAIL_FETCH_RECEIPT_LIST = 'FAIL_FETCH_RECEIPT_LIST';
export const failFetchReceiptList = createAction(FAIL_FETCH_RECEIPT_LIST);
export const SET_RECEIPT_LIST_DATA = 'SET_RECEIPT_LIST_DATA';
export const setReceiptListData = createAction(SET_RECEIPT_LIST_DATA);

export const GET_PDF_ITEMS_RECEIPT = 'GET_PDF_ITEMS_RECEIPT';
export const getPdfItemsReceipt = createAction(GET_PDF_ITEMS_RECEIPT);
export const FAIL_GET_PDF_ITEMS_RECEIPT = 'FAIL_GET_PDF_ITEMS_RECEIPT';
export const failGetPdfItemsReceipt = createAction(FAIL_GET_PDF_ITEMS_RECEIPT);
export const SET_PDF_ITEMS_RECEIPT = 'SET_PDF_ITEMS_RECEIPT';
export const setPdfItemsReceipt = createAction(SET_PDF_ITEMS_RECEIPT);
export const CLEAR_PDF_ITEMS_RECEIPT = 'CLEAR_PDF_ITEMS_RECEIPT';
export const clearPdfItemsReceipt = createAction(CLEAR_PDF_ITEMS_RECEIPT);

export const GET_PDF_ITEMS_RECEIPT_MOD = 'GET_PDF_ITEMS_RECEIPT_MOD';
export const getPdfItemsReceiptMod = createAction(GET_PDF_ITEMS_RECEIPT_MOD);
export const FAIL_GET_PDF_ITEMS_RECEIPT_MOD = 'FAIL_GET_PDF_ITEMS_RECEIPT_MOD';
export const failGetPdfItemsReceiptMod = createAction(FAIL_GET_PDF_ITEMS_RECEIPT_MOD);
export const SET_PDF_ITEMS_RECEIPT_MOD = 'SET_PDF_ITEMS_RECEIPT_MOD';
export const setPdfItemsReceiptMod = createAction(SET_PDF_ITEMS_RECEIPT_MOD);
export const CLEAR_PDF_ITEMS_RECEIPT_MOD = 'CLEAR_PDF_ITEMS_RECEIPT_MOD';
export const clearPdfItemsReceiptMod = createAction(CLEAR_PDF_ITEMS_RECEIPT_MOD);

export const GET_PDF_ITEMS_RECEIPT_SECOM = 'GET_PDF_ITEMS_RECEIPT_SECOM';
export const getPdfItemsReceiptSecom = createAction(GET_PDF_ITEMS_RECEIPT_SECOM);
export const FAIL_GET_PDF_ITEMS_RECEIPT_SECOM = 'FAIL_GET_PDF_ITEMS_RECEIPT_SECOM';
export const failGetPdfItemsReceiptSecom = createAction(FAIL_GET_PDF_ITEMS_RECEIPT_SECOM);
export const SET_PDF_ITEMS_RECEIPT_SECOM = 'SET_PDF_ITEMS_RECEIPT_SECOM';
export const setPdfItemsReceiptSecom = createAction(SET_PDF_ITEMS_RECEIPT_SECOM);
export const CLEAR_PDF_ITEMS_RECEIPT_SECOM = 'CLEAR_PDF_ITEMS_RECEIPT_SECOM';
export const clearPdfItemsReceiptSecom = createAction(CLEAR_PDF_ITEMS_RECEIPT_SECOM);

export const UNDO_RECEIPT_FLAG = 'UNDO_RECEIPT_FLAG';
export const undoReceiptFlag = createAction(UNDO_RECEIPT_FLAG);
export const FAIL_UNDO_RECEIPT_FLAG = 'FAIL_UNDO_RECEIPT_FLAG';
export const failUndoReceiptFlag = createAction(FAIL_UNDO_RECEIPT_FLAG);
export const SUCCESS_UNDO_RECEIPT_FLAG = 'SUCCESS_UNDO_RECEIPT_FLAG';
export const successUndoReceiptFlag = createAction(SUCCESS_UNDO_CONSIGNEE_FLAG_NEW);


export const GET_RECEIPT_ARRIVAL_PDF = 'GET_RECEIPT_ARRIVAL_PDF';
export const getReceiptArrivalPdf = createAction(GET_RECEIPT_ARRIVAL_PDF);
export const FAIL_GET_RECEIPT_ARRIVAL_PDF = 'FAIL_GET_RECEIPT_ARRIVAL_PDF';
export const failGetReceiptArrivalPdf = createAction(FAIL_GET_RECEIPT_ARRIVAL_PDF);
export const SUCCESS_GET_RECEIPT_ARRIVAL_PDF = 'SUCCESS_GET_RECEIPT_ARRIVAL_PDF';
export const successGetReceiptArrivalPdf = createAction(SUCCESS_GET_RECEIPT_ARRIVAL_PDF);
export const CLEAR_PDF_ITEMS_RECEIPT_ARRIVAL = 'CLEAR_PDF_ITEMS_RECEIPT_ARRIVAL';
export const clearPdfItemsReceiptArrival = createAction(CLEAR_PDF_ITEMS_RECEIPT_ARRIVAL);


/*ARRIVAL LIST*/
export const FETCH_ARRIVAL_LIST = 'FETCH_ARRIVAL_LIST';
export const fetchArrivalList = createAction(FETCH_ARRIVAL_LIST);
export const FAIL_FETCH_ARRIVAL_LIST = 'FAIL_FETCH_ARRIVAL_LIST';
export const failFetchArrivalList = createAction(FAIL_FETCH_ARRIVAL_LIST);
export const SET_ARRIVAL_LIST_DATA = 'SET_ARRIVAL_LIST_DATA';
export const setArrivalListData = createAction(SET_ARRIVAL_LIST_DATA);

export const SET_ARRIVAL_LIST_STATE = 'SET_ARRIVAL_LIST_STATE';
export const setArrivalListState = createAction(SET_ARRIVAL_LIST_STATE);
export const RESET_ARRIVAL_LIST_STATE = 'RESET_ARRIVAL_LIST_STATE';
export const resetArrivalListState = createAction(RESET_ARRIVAL_LIST_STATE);

export const UPDATE_ARRIVAL_FLAG = 'UPDATE_ARRIVAL_FLAG';
export const updateArrivalFlag = createAction(UPDATE_ARRIVAL_FLAG);
export const FAIL_UPDATE_ARRIVAL_FLAG = 'FAIL_UPDATE_ARRIVAL_FLAG';
export const failUpdateArrivalFlag = createAction(FAIL_UPDATE_ARRIVAL_FLAG);
export const SUCCESS_UPDATE_ARRIVAL_FLAG = 'SUCCESS_UPDATE_ARRIVAL_FLAG';
export const successUpdateArrivalFlag = createAction(SUCCESS_UPDATE_ARRIVAL_FLAG);

export const UNDO_ARRIVAL_FLAG = 'UNDO_ARRIVAL_FLAG';
export const undoArrivalFlag = createAction(UNDO_ARRIVAL_FLAG);
export const FAIL_UNDO_ARRIVAL_FLAG = 'FAIL_UNDO_ARRIVAL_FLAG';
export const failUndoArrivalFlag = createAction(FAIL_UNDO_ARRIVAL_FLAG);
export const SUCCESS_UNDO_ARRIVAL_FLAG = 'SUCCESS_UNDO_ARRIVAL_FLAG';
export const successUndoArrivalFlag = createAction(SUCCESS_UNDO_ARRIVAL_FLAG);

export const GET_PDF_ITEMS_ARRIVAL = 'GET_PDF_ITEMS_ARRIVAL';
export const getPdfItemsArrival = createAction(GET_PDF_ITEMS_ARRIVAL);
export const FAIL_GET_PDF_ITEMS_ARRIVAL = 'FAIL_GET_PDF_ITEMS_ARRIVAL';
export const failGetPdfItemsArrival = createAction(FAIL_GET_PDF_ITEMS_ARRIVAL);
export const SET_PDF_ITEMS_ARRIVAL = 'SET_PDF_ITEMS_ARRIVAL';
export const setPdfItemsArrival = createAction(SET_PDF_ITEMS_ARRIVAL);
export const CLEAR_PDF_ITEMS_ARRIVAL = 'CLEAR_PDF_ITEMS_ARRIVAL';
export const clearPdfItemsArrival = createAction(CLEAR_PDF_ITEMS_ARRIVAL);


/*DELETE LIST*/
export const FETCH_DELETE_LIST = 'FETCH_DELETE_LIST';
export const fetchDeleteList = createAction(FETCH_DELETE_LIST);
export const FAIL_FETCH_DELETE_LIST = 'FAIL_FETCH_DELETE_LIST';
export const failFetchDeleteList = createAction(FAIL_FETCH_DELETE_LIST);
export const SET_DELETE_LIST_DATA = 'SET_DELETE_LIST_DATA';
export const setDeleteListData = createAction(SET_DELETE_LIST_DATA);

export const RESET_DELETE_LIST_STATE = 'RESET_DELETE_LIST_STATE';
export const resetDeleteListState = createAction(RESET_DELETE_LIST_STATE);

export const UPDATE_DELETE_FLAG = 'UPDATE_DELETE_FLAG';
export const updateDeleteFlag = createAction(UPDATE_DELETE_FLAG);
export const FAIL_UPDATE_DELETE_FLAG = 'FAIL_UPDATE_DELETE_FLAG';
export const failUpdateDeleteFlag = createAction(FAIL_UPDATE_DELETE_FLAG);
export const SUCCESS_UPDATE_DELETE_FLAG = 'SUCCESS_UPDATE_DELETE_FLAG';
export const successUpdateDeleteFlag = createAction(SUCCESS_UPDATE_DELETE_FLAG);


/*UPLOAD RECEIPT*/
export const SET_UPLOAD_RECEIPT_LIST = 'SET_UPLOAD_RECEIPT_LIST';
export const setUploadReceiptList = createAction(SET_UPLOAD_RECEIPT_LIST);
export const UPLOAD_DECODE_TARGET = 'UPLOAD_DECODE_TARGET';
export const uploadDecodeTarget = createAction(UPLOAD_DECODE_TARGET);
export const SUCCESS_UPLOAD_DECODE_TARGET = 'SUCCESS_UPLOAD_DECODE_TARGET';
export const successUploadDecodeTarget = createAction(SUCCESS_UPLOAD_DECODE_TARGET);
export const FAIL_UPLOAD_DECODE_TARGET = 'FAIL_UPLOAD_DECODE_TARGET';
export const failUploadDecodeTarget = createAction(FAIL_UPLOAD_DECODE_TARGET);
export const OPEN_RECEIPT_MANUAL_INPUT = 'OPEN_RECEIPT_MANUAL_INPUT';
export const openReceiptManualInput = createAction(OPEN_RECEIPT_MANUAL_INPUT);

export const UPLOAD_MANUAL_DECODE = 'UPLOAD_MANUAL_DECODE';
export const uploadManualDecode = createAction(UPLOAD_MANUAL_DECODE);
export const SUCCESS_UPLOAD_MANUAL_DECODE = 'SUCCESS_UPLOAD_MANUAL_DECODE';
export const successUploadManualDecode = createAction(SUCCESS_UPLOAD_MANUAL_DECODE);
export const FAIL_UPLOAD_MANUAL_DECODE = 'FAIL_UPLOAD_MANUAL_DECODE';
export const failUploadManualDecode = createAction(FAIL_UPLOAD_MANUAL_DECODE);

export const RESET_UPLOAD_RECEIPT_STATE = 'RESET_UPLOAD_RECEIPT_STATE';
export const resetUploadReceiptState = createAction(RESET_UPLOAD_RECEIPT_STATE);

/*UPLOAD RECEIPT(NEW)*/
export const SET_UPLOAD_RECEIPT_LIST_NEW = 'SET_UPLOAD_RECEIPT_LIST_NEW';
export const setUploadReceiptListNew = createAction(SET_UPLOAD_RECEIPT_LIST_NEW);
export const UPLOAD_DECODE_TARGET_NEW = 'UPLOAD_DECODE_TARGET_NEW';
export const uploadDecodeTargetNew = createAction(UPLOAD_DECODE_TARGET_NEW);
export const SUCCESS_UPLOAD_DECODE_TARGET_NEW = 'SUCCESS_UPLOAD_DECODE_TARGET_NEW';
export const successUploadDecodeTargetNew = createAction(SUCCESS_UPLOAD_DECODE_TARGET_NEW);
export const FAIL_UPLOAD_DECODE_TARGET_NEW = 'FAIL_UPLOAD_DECODE_TARGET_NEW';
export const failUploadDecodeTargetNew = createAction(FAIL_UPLOAD_DECODE_TARGET_NEW);

export const RESET_UPLOAD_RECEIPT_STATE_NEW = 'RESET_UPLOAD_RECEIPT_STATE_NEW';
export const resetUploadReceiptStateNew = createAction(RESET_UPLOAD_RECEIPT_STATE_NEW);

export const FETCH_DECODE_PROCESS_MANUAL_COUNT = 'FETCH_DECODE_PROCESS_MANUAL_COUNT';
export const fetchDecodeProcessManualCount = createAction(FETCH_DECODE_PROCESS_MANUAL_COUNT);
export const FAIL_FETCH_DECODE_PROCESS_MANUAL_COUNT = 'FAIL_FETCH_DECODE_PROCESS_MANUAL_COUNT';
export const failFetchDecodeProcessManualCount = createAction(FAIL_FETCH_DECODE_PROCESS_MANUAL_COUNT);
export const SET_DECODE_PROCESS_MANUAL_COUNT = 'SET_DECODE_PROCESS_MANUAL_COUNT';
export const setDecodeProcessManualCount = createAction(SET_DECODE_PROCESS_MANUAL_COUNT);


/*DECODE PROCESS LIST*/
export const FETCH_DECODE_PROCESS_LIST = 'FETCH_DECODE_PROCESS_LIST';
export const fetchDecodeProcessList = createAction(FETCH_DECODE_PROCESS_LIST);
export const FAIL_FETCH_DECODE_PROCESS_LIST = 'FAIL_FETCH_DECODE_PROCESS_LIST';
export const failFetchDecodeProcessList = createAction(FAIL_FETCH_DECODE_PROCESS_LIST);
export const SET_DECODE_PROCESS_LIST_DATA = 'SET_DECODE_PROCESS_LIST_DATA';
export const setDecodeProcessListData = createAction(SET_DECODE_PROCESS_LIST_DATA);

export const RESET_DECODE_PROCESS_LIST_STATE = 'RESET_DECODE_PROCESS_LIST_STATE';
export const resetDecodeProcessListState = createAction(RESET_DECODE_PROCESS_LIST_STATE);

export const UPLOAD_MANUAL_DECODE_NEW = 'UPLOAD_MANUAL_DECODE_NEW';
export const uploadManualDecodeNew = createAction(UPLOAD_MANUAL_DECODE_NEW);
export const SUCCESS_UPLOAD_MANUAL_DECODE_NEW = 'SUCCESS_UPLOAD_MANUAL_DECODE_NEW';
export const successUploadManualDecodeNew = createAction(SUCCESS_UPLOAD_MANUAL_DECODE_NEW);
export const FAIL_UPLOAD_MANUAL_DECODE_NEW = 'FAIL_UPLOAD_MANUAL_DECODE_NEW';
export const failUploadManualDecodeNew = createAction(FAIL_UPLOAD_MANUAL_DECODE_NEW);

export const CANCEL_MANUAL_DECODE = 'CANCEL_MANUAL_DECODE';
export const cancelManualDecode = createAction(CANCEL_MANUAL_DECODE);
export const SUCCESS_CANCEL_MANUAL_DECODE = 'SUCCESS_CANCEL_MANUAL_DECODE';
export const successCancelManualDecode = createAction(SUCCESS_CANCEL_MANUAL_DECODE);
export const FAIL_CANCEL_MANUAL_DECODE = 'FAIL_CANCEL_MANUAL_DECODE';
export const failCancelManualDecode = createAction(FAIL_CANCEL_MANUAL_DECODE);


/*PRINT*/
export const GET_PDF_ITEMS = 'GET_PDF_ITEM';
export const getPdfItems = createAction(GET_PDF_ITEMS);
export const FAIL_GET_PDF_ITEMS = 'FAIL_GET_PDF_ITEMS';
export const failGetPdfItems = createAction(FAIL_GET_PDF_ITEMS);
export const SET_PDF_ITEMS = 'SET_PDF_ITEMS';
export const setPdfItems = createAction(SET_PDF_ITEMS);
export const CLEAR_PDF_ITEMS = 'CLEAR_PDF_ITEMS';
export const clearPdfItems = createAction(CLEAR_PDF_ITEMS);
export const UPDATE_PRINT_FLAG = 'UPDATE_PRINT_FLAG';
export const updatePrintFlag = createAction(UPDATE_PRINT_FLAG);
export const FAIL_UPDATE_PRINT_FLAG = 'FAIL_UPDATE_PRINT_FLAG';
export const failUpdatePrintFlag = createAction(FAIL_UPDATE_PRINT_FLAG);
export const SUCCESS_UPDATE_PRINT_FLAG = 'SUCCESS_UPDATE_PRINT_FLAG';
export const successUpdatePrintFlag = createAction(SUCCESS_UPDATE_PRINT_FLAG);


/*CSV*/
export const FETCH_CSV_DATA_MAIN = 'FETCH_CSV_DATA_MAIN';
export const fetchCsvDataMain = createAction(FETCH_CSV_DATA_MAIN);
export const FAIL_FETCH_CSV_DATA_MAIN = 'FAIL_FETCH_CSV_DATA_MAIN';
export const failFetchCsvDataMain = createAction(FAIL_FETCH_CSV_DATA_MAIN);
export const SET_CSV_DATA_MAIN = 'SET_CSV_DATA_MAIN';
export const setCsvDataMain = createAction(SET_CSV_DATA_MAIN);

export const FETCH_CSV_DATA_DETAIL = 'FETCH_CSV_DATA_DETAIL';
export const fetchCsvDataDetail = createAction(FETCH_CSV_DATA_DETAIL);
export const FAIL_FETCH_CSV_DATA_DETAIL = 'FAIL_FETCH_CSV_DATA_DETAIL';
export const failFetchCsvDataDetail = createAction(FAIL_FETCH_CSV_DATA_DETAIL);
export const SET_CSV_DATA_DETAIL = 'SET_CSV_DATA_DETAIL';
export const setCsvDataDetail = createAction(SET_CSV_DATA_DETAIL);

export const FETCH_CSV_DATA_RECEIPT = 'FETCH_CSV_DATA_RECEIPT';
export const fetchCsvDataReceipt = createAction(FETCH_CSV_DATA_RECEIPT);
export const FAIL_FETCH_CSV_DATA_RECEIPT = 'FAIL_FETCH_CSV_DATA_RECEIPT';
export const failFetchCsvDataReceipt = createAction(FAIL_FETCH_CSV_DATA_RECEIPT);
export const SET_CSV_DATA_RECEIPT = 'SET_CSV_DATA_RECEIPT';
export const setCsvDataReceipt = createAction(SET_CSV_DATA_RECEIPT);

export const FETCH_CSV_DATA_ARRIVAL = 'FETCH_CSV_DATA_ARRIVAL';
export const fetchCsvDataArrival = createAction(FETCH_CSV_DATA_ARRIVAL);
export const FAIL_FETCH_CSV_DATA_ARRIVAL = 'FAIL_FETCH_CSV_DATA_ARRIVAL';
export const failFetchCsvDataArrival = createAction(FAIL_FETCH_CSV_DATA_ARRIVAL);
export const SET_CSV_DATA_ARRIVAL = 'SET_CSV_DATA_ARRIVAL';
export const setCsvDataArrival = createAction(SET_CSV_DATA_ARRIVAL);

export const FETCH_CSV_DATA_CONSIGNEE_LIST_NEW = 'FETCH_CSV_DATA_CONSIGNEE_LIST_NEW';
export const fetchCsvDataConsigneeListNew = createAction(FETCH_CSV_DATA_CONSIGNEE_LIST_NEW);
export const FAIL_FETCH_CSV_DATA_CONSIGNEE_LIST_NEW = 'FAIL_FETCH_CSV_DATA_CONSIGNEE_LIST_NEW';
export const failFetchCsvDataConsigneeListNew = createAction(FAIL_FETCH_CSV_DATA_CONSIGNEE_LIST_NEW);
export const SET_CSV_DATA_CONSIGNEE_LIST_NEW = 'SET_CSV_DATA_CONSIGNEE_LIST_NEW';
export const setCsvDataConsigneeListNew = createAction(SET_CSV_DATA_CONSIGNEE_LIST_NEW);

export const FETCH_CSV_DATA_DELIVERY_STATUS = 'FETCH_CSV_DATA_DELIVERY_STATUS';
export const fetchCsvDataDeliveryStatus = createAction(FETCH_CSV_DATA_DELIVERY_STATUS);
export const FAIL_FETCH_CSV_DATA_DELIVERY_STATUS = 'FAIL_FETCH_CSV_DATA_DELIVERY_STATUS';
export const failFetchCsvDataDeliveryStatus = createAction(FAIL_FETCH_CSV_DATA_DELIVERY_STATUS);
export const SET_CSV_DATA_DELIVERY_STATUS = 'SET_CSV_DATA_DELIVERY_STATUS';
export const setCsvDataDeliveryStatus = createAction(SET_CSV_DATA_DELIVERY_STATUS);

export const FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL = 'FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL';
export const fetchCsvDataDeliveryStatusDetail = createAction(FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL);
export const FAIL_FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL = 'FAIL_FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL';
export const failFetchCsvDataDeliveryStatusDetail = createAction(FAIL_FETCH_CSV_DATA_DELIVERY_STATUS_DETAIL);
export const SET_CSV_DATA_DELIVERY_STATUS_DETAIL = 'SET_CSV_DATA_DELIVERY_STATUS_DETAIL';
export const setCsvDataDeliveryStatusDetail = createAction(SET_CSV_DATA_DELIVERY_STATUS_DETAIL);

/*EMPTY_PDF*/
export const FETCH_EMPTY_PDF_LIST = 'FETCH_EMPTY_PDF_LIST';
export const fetchEmptyPdfList = createAction(FETCH_EMPTY_PDF_LIST);
export const FAIL_FETCH_EMPTY_PDF_LIST = 'FAIL_FETCH_EMPTY_PDF_LIST';
export const failFetchEmptyPdfList = createAction(FAIL_FETCH_EMPTY_PDF_LIST);
export const SET_EMPTY_PDF_LIST_DATA = 'SET_EMPTY_PDF_LIST_DATA';
export const setEmptyPdfList = createAction(SET_EMPTY_PDF_LIST_DATA);

export const GET_EMPTY_PDF_ITEMS = 'GET_EMPTY_PDF_ITEMS';
export const getEmptyPdfItems = createAction(GET_EMPTY_PDF_ITEMS);
export const FAIL_GET_EMPTY_PDF_ITEMS = 'FAIL_GET_EMPTY_PDF_ITEMS';
export const failGetEmptyPdfItems = createAction(FAIL_GET_EMPTY_PDF_ITEMS);
export const SET_EMPTY_PDF_ITEMS = 'SET_EMPTY_PDF_ITEMS';
export const setEmptyPdfItems = createAction(SET_EMPTY_PDF_ITEMS);
export const CLEAR_EMPTY_PDF_ITEMS = 'CLEAR_EMPTY_PDF_ITEMS';
export const clearEmptyPdfItems = createAction(CLEAR_EMPTY_PDF_ITEMS);

/*INFORMATION*/
export const FETCH_INFORMATION_LIST = 'FETCH_INFORMATION_LIST';
export const fetchInformationList = createAction(FETCH_INFORMATION_LIST);
export const FAIL_FETCH_INFORMATION_LIST = 'FAIL_FETCH_INFORMATION_LIST';
export const failFetchInformationList = createAction(FAIL_FETCH_INFORMATION_LIST);
export const SET_INFORMATION_DATA = 'SET_INFORMATION_DATA';
export const setInformationList = createAction(SET_INFORMATION_DATA);


/*FAQ*/
export const FETCH_FAQ_LIST = 'FETCH_FAQ_LIST';
export const fetchFaqList = createAction(FETCH_FAQ_LIST);
export const FAIL_FETCH_FAQ_LIST = 'FAIL_FETCH_FAQ_LIST';
export const failFetchFaqList = createAction(FAIL_FETCH_FAQ_LIST);
export const SET_FAQ_DATA = 'SET_FAQ_DATA';
export const setFaqList = createAction(SET_FAQ_DATA);

/*STATISTICS*/
export const SET_STATISTICS_STATUS = 'SET_STATISTICS_STATUS';
export const setStatisticsStatus = createAction(SET_STATISTICS_STATUS);

export const RESET_STATISTICS_STATUS = 'RESET_STATISTICS_STATUS';
export const resetStatisticsStatus = createAction(RESET_STATISTICS_STATUS);

export const FETCH_STATISTICS_INFO = 'FETCH_STATISTICS_INFO';
export const fetchStatisticsInfo = createAction(FETCH_STATISTICS_INFO);
export const FAIL_FETCH_STATISTICS_INFO = 'FAIL_FETCH_STATISTICS_INFO';
export const failFetchStatisticsInfo = createAction(FAIL_FETCH_STATISTICS_INFO);
export const SET_STATISTICS_INFO = 'SET_STATISTICS_INFO';
export const setStatisticsInfo = createAction(SET_STATISTICS_INFO);

export const ADD_STATISTICS_INFO = 'ADD_STATISTICS_INFO';
export const addStatisticsInfo = createAction(ADD_STATISTICS_INFO);
export const FAIL_ADD_STATISTICS_INFO = 'FAIL_ADD_STATISTICS_INFO';
export const failAddStatisticsInfo = createAction(FAIL_ADD_STATISTICS_INFO);
export const SUCCESS_ADD_STATISTICS_INFO = 'SUCCESS_ADD_STATISTICS_INFO';
export const successAddStatisticsInfo = createAction(SUCCESS_ADD_STATISTICS_INFO);


export const UPD_STATISTICS_INFO = 'UPD_STATISTICS_INFO';
export const updStatisticsInfo = createAction(UPD_STATISTICS_INFO);
export const FAIL_UPD_STATISTICS_INFO = 'FAIL_UPD_STATISTICS_INFO';
export const failUpdStatisticsInfo = createAction(FAIL_UPD_STATISTICS_INFO);
export const SUCCESS_UPD_STATISTICS_INFO = 'SUCCESS_UPD_STATISTICS_INFO';
export const successUpdStatisticsInfo = createAction(SUCCESS_UPD_STATISTICS_INFO);

export const DEL_STATISTICS_INFO = 'DEL_STATISTICS_INFO';
export const delStatisticsInfo = createAction(DEL_STATISTICS_INFO);
export const FAIL_DEL_STATISTICS_INFO = 'FAIL_DEL_STATISTICS_INFO';
export const failDelStatisticsInfo = createAction(FAIL_DEL_STATISTICS_INFO);
export const SUCCESS_DEL_STATISTICS_INFO = 'SUCCESS_DEL_STATISTICS_INFO';
export const successDelStatisticsInfo = createAction(SUCCESS_DEL_STATISTICS_INFO);


/*STATISTICS LIST*/
export const RESET_STATISTICS_LIST_STATUS = 'RESET_STATISTICS_LIST_STATUS';
export const resetStatisticsListStatus = createAction(RESET_STATISTICS_LIST_STATUS);

export const FETCH_STATISTICS_LIST = 'FETCH_STATISTICS_LIST';
export const fetchStatisticsList = createAction(FETCH_STATISTICS_LIST);
export const FAIL_FETCH_STATISTICS_LIST = 'FAIL_FETCH_STATISTICS_LIST';
export const failFetchStatisticsList = createAction(FAIL_FETCH_STATISTICS_LIST);
export const SET_STATISTICS_LIST = 'SET_STATISTICS_LIST';
export const setStatisticsList = createAction(SET_STATISTICS_LIST);


export const GET_STATISTICS_EXCEL = 'GET_STATISTICS_EXCEL';
export const getStatisticsExcel = createAction(GET_STATISTICS_EXCEL);
export const FAIL_GET_STATISTICS_EXCEL = 'FAIL_GET_STATISTICS_EXCEL';
export const failGetStatisticsExcel = createAction(FAIL_GET_STATISTICS_EXCEL);
export const SUCCESS_GET_STATISTICS_EXCEL = 'SUCCESS_GET_STATISTICS_EXCEL';
export const successGetStatisticsExcel = createAction(SUCCESS_GET_STATISTICS_EXCEL);

/*SHIPMENT*/
export const FETCH_SHIPMENT_ROTATION_NO = 'FETCH_SHIPMENT_ROTATION_NO';
export const fetchShipmentRotationNO = createAction(FETCH_SHIPMENT_ROTATION_NO);
export const FAIL_FETCH_SHIPMENT_ROTATION_NO = 'FAIL_FETCH_SHIPMENT_ROTATION_NO';
export const failFetchShipmentRotationNO = createAction(FAIL_FETCH_SHIPMENT_ROTATION_NO);
export const SUCCESS_FETCH_SHIPMENT_ROTATION_NO = 'SUCCESS_FETCH_SHIPMENT_ROTATION_NO';
export const successFetchShipmentRotationNO = createAction(SUCCESS_FETCH_SHIPMENT_ROTATION_NO);

export const FETCH_SHIPMENT_DATA = 'FETCH_SHIPMENT_DATA';
export const fetchShipmentData = createAction(FETCH_SHIPMENT_DATA);
export const FAIL_FETCH_SHIPMENT_DATA = 'FAIL_FETCH_SHIPMENT_DATA';
export const failFetchShipmentData = createAction(FAIL_FETCH_SHIPMENT_DATA);
export const SET_SHIPMENT_DATA = 'SET_SHIPMENT_DATA';
export const setShipmentData = createAction(SET_SHIPMENT_DATA);

export const SET_SHIPMENT_STATE = 'SET_SHIPMENT_STATE';
export const setShipmentState = createAction(SET_SHIPMENT_STATE);
export const RESET_SHIPMENT_STATE = 'RESET_SHIPMENT_STATE';
export const resetShipmentState = createAction(RESET_SHIPMENT_STATE);

export const UPDATE_SHIPMENT_FLAG = 'UPDATE_SHIPMENT_FLAG';
export const updateShipmentFlag = createAction(UPDATE_SHIPMENT_FLAG);
export const FAIL_UPDATE_SHIPMENT_FLAG = 'FAIL_UPDATE_SHIPMENT_FLAG';
export const failUpdateShipmentFlag = createAction(FAIL_UPDATE_SHIPMENT_FLAG);
export const SUCCESS_UPDATE_SHIPMENT_FLAG = 'SUCCESS_UPDATE_SHIPMENT_FLAG';
export const successUpdateShipmentFlag = createAction(SUCCESS_UPDATE_SHIPMENT_FLAG);

/*SHIPMENT DETAIL*/
export const SET_SHIPMENT_SELECTIONS = 'SET_SHIPMENT_SELECTIONS';
export const setShipmentSelections = createAction(SET_SHIPMENT_SELECTIONS);

export const FETCH_SHIPMENT_DETAIL = 'FETCH_SHIPMENT_DETAIL';
export const fetchShipmentDetail = createAction(FETCH_SHIPMENT_DETAIL);
export const FAIL_FETCH_SHIPMENT_DETAIL = 'FAIL_FETCH_SHIPMENT_DETAIL';
export const failfetchShipmentDetail = createAction(FAIL_FETCH_SHIPMENT_DETAIL);
export const SET_SHIPMENT_DETAIL_DATA = 'SET_SHIPMENT_DETAIL_DATA';
export const setShipmentDetailData = createAction(SET_SHIPMENT_DETAIL_DATA);
export const RESET_SHIPMENT_DETAIL_STATE = 'RESET_SHIPMENT_DETAIL_STATE';
export const resetShipmentDetailState = createAction(RESET_SHIPMENT_DETAIL_STATE);

export const GET_PDF_ITEMS_SHIPMENT = 'GET_PDF_ITEMS_SHIPMENT';
export const getPdfItemsShipment = createAction(GET_PDF_ITEMS_SHIPMENT);
export const FAIL_GET_PDF_ITEMS_SHIPMENT = 'FAIL_GET_PDF_ITEMS_SHIPMENT';
export const failGetPdfItemsShipment = createAction(FAIL_GET_PDF_ITEMS_SHIPMENT);
export const SET_PDF_ITEMS_SHIPMENT = 'SET_PDF_ITEMS_SHIPMENT';
export const setPdfItemsShipment = createAction(SET_PDF_ITEMS_SHIPMENT);
export const CLEAR_PDF_ITEMS_SHIPMENT = 'CLEAR_PDF_ITEMS_SHIPMENT';
export const clearPdfItemsShipment = createAction(CLEAR_PDF_ITEMS_SHIPMENT);

export const SAVE_SHIPMENT_DETAIL = `SAVE_SHIPMENT_DETAIL`;
export const saveShipmentDetail = createAction(SAVE_SHIPMENT_DETAIL);
export const FAIL_SAVE_SHIPMENT_DETAIL = 'FAIL_SAVE_SHIPMENT_DETAIL';
export const failSaveShipmentDetail = createAction(FAIL_SAVE_SHIPMENT_DETAIL);
export const SUCCESS_SAVE_SHIPMENT_DETAIL = 'SUCCESS_SAVE_SHIPMENT_DETAIL';
export const successSaveShipmentDetail = createAction(SUCCESS_SAVE_SHIPMENT_DETAIL);

/*ENTRY LIST*/
export const FETCH_ENTRY_LIST = 'FETCH_ENTRY_LIST';
export const fetchEntryList = createAction(FETCH_ENTRY_LIST);
export const FAIL_FETCH_ENTRY_LIST = 'FAIL_FETCH_ENTRY_LIST';
export const failFetchEntryList = createAction(FAIL_FETCH_ENTRY_LIST);
export const SET_ENTRY_LIST_DATA = 'SET_ENTRY_LIST_DATA'
export const setEntryListData = createAction(SET_ENTRY_LIST_DATA);

export const SET_ENTRY_LIST_STATE = 'SET_ENTRY_LIST_STATE';
export const setEntryListState = createAction(SET_ENTRY_LIST_STATE);
export const RESET_ENTRY_LIST_STATE = 'RESET_ENTRY_LIST_STATE';
export const resetEntryListState = createAction(RESET_ENTRY_LIST_STATE);

export const SET_ENTRY_STATE = 'SET_ENTRY_STATE';
export const setEntryState = createAction(SET_ENTRY_STATE);

export const CLEAR_PDF_ITEMS_Entry = 'CLEAR_PDF_ITEMS_Entry';
export const clearPdfItemsEntry = createAction(CLEAR_PDF_ITEMS_Entry);

export const DELETE_ENTRY_LIST = 'DELETE_ENTRY_LIST';
export const deleteEntryList = createAction(DELETE_ENTRY_LIST);
export const FAIL_DELETE_ENTRY_LIST = 'FAIL_DELETE_ENTRY_LIST';
export const failDeleteEntryList = createAction(FAIL_DELETE_ENTRY_LIST);
export const SUCCESS_DELETE_ENTRY_LIST = 'SUCCESS_DELETE_ENTRY_LIST';
export const successDeleteEntryList = createAction(SUCCESS_DELETE_ENTRY_LIST);

/*ENTRY DETAIL*/
export const RESET_ENTRY_DETAIL_STATE = 'RESET_ENTRY_DETAIL_STATE';
export const resetEntryDetailState = createAction(RESET_ENTRY_DETAIL_STATE);

export const FETCH_ENTRY_DETAIL_DATA = 'FETCH_ENTRY_DETAIL_DATA';
export const fetchEntryDetailData = createAction(FETCH_ENTRY_DETAIL_DATA);
export const FAIL_FETCH_ENTRY_DETAIL_DATA = 'FAIL_FETCH_ENTRY_DETAIL_DATA';
export const failFetchEntryDetailData = createAction(FAIL_FETCH_ENTRY_DETAIL_DATA);
export const SUCCESS_FETCH_ENTRY_DETAIL_DATA = 'SUCCESS_FETCH_ENTRY_DETAIL_DATA';
export const successFetchEntryDetailData = createAction(SUCCESS_FETCH_ENTRY_DETAIL_DATA);

export const SAVE_ENTRY_STATE = 'SAVE_ENTRY_STATE'
export const saveEntryState = createAction(SAVE_ENTRY_STATE);
export const FAIL_SAVE_ENTRY_STATE = 'FAIL_SAVE_ENTRY_STATE'
export const failSaveEntryState = createAction(FAIL_SAVE_ENTRY_STATE);
export const SUCCESS_SAVE_ENTRY_STATE = 'SUCCESS_SAVE_ENTRY_STATE'
export const successSaveEntryState = createAction(SUCCESS_SAVE_ENTRY_STATE);

export const SET_ENTRY_DETAIL_STATE = 'SET_ENTRY_DETAIL_STATE';
export const setEntryDetailState = createAction(SET_ENTRY_DETAIL_STATE);

/*DELIVERY STATUS LIST*/
export const FETCH_DELIVERY_STATUS_LIST = 'FETCH_DELIVERY_STATUS_LIST';
export const fetchDeliveryStatusList = createAction(FETCH_DELIVERY_STATUS_LIST);
export const FAIL_FETCH_DELIVERY_STATUS_LIST = 'FAIL_FETCH_DELIVERY_STATUS_LIST';
export const failFetchDeliveryStatusList = createAction(FAIL_FETCH_DELIVERY_STATUS_LIST);
export const SET_DELIVERY_STATUS_DATA = 'SET_DELIVERY_STATUS_DATA';
export const setDeliveryStatusData = createAction(SET_DELIVERY_STATUS_DATA);

export const SET_DELIVERY_STATUS_LIST_STATE = 'SET_DELIVERY_STATUS_LIST_STATE';
export const setDeliveryStatusListState = createAction(SET_DELIVERY_STATUS_LIST_STATE);

export const RESET_DELIVERY_STATUS_LIST_STATE = 'RESET_DELIVERY_STATUS_LIST_STATE';
export const resetDeliveryStatusListState = createAction(RESET_DELIVERY_STATUS_LIST_STATE);

/*DELIVERY STATUS DETAIL*/
export const SET_DELIVERY_STATUS_LIST_SELECTIONS = 'SET_DELIVERY_STATUS_LIST_SELECTIONS';
export const setDeliveryStatusListSelections = createAction(SET_DELIVERY_STATUS_LIST_SELECTIONS);

export const GET_PDF_ITEMS_DELIVERY_STATUS = 'GET_PDF_ITEMS_DELIVERY_STATUS';
export const getPdfItemsDeliveryStatus = createAction(GET_PDF_ITEMS_DELIVERY_STATUS);
export const FAIL_GET_PDF_ITEMS_DELIVERY_STATUS = 'FAIL_GET_PDF_ITEMS_DELIVERY_STATUS';
export const failGetPdfItemsDeliveryStatus = createAction(FAIL_GET_PDF_ITEMS_DELIVERY_STATUS);
export const SET_PDF_ITEMS_DELIVERY_STATUS = 'SET_PDF_ITEMS_DELIVERY_STATUS';
export const setPdfItemsDeliveryStatus = createAction(SET_PDF_ITEMS_DELIVERY_STATUS);
export const CLEAR_PDF_ITEMS_DELIVERY_STATUS = 'CLEAR_PDF_ITEMS_DELIVERY_STATUS';
export const clearPdfItemsDeliveryStatus = createAction(CLEAR_PDF_ITEMS_DELIVERY_STATUS);

export const FETCH_DELIVERY_STATUS_DETAIL = 'FETCH_DELIVERY_STATUS_DETAIL';
export const fetchDeliveryStatusDetail = createAction(FETCH_DELIVERY_STATUS_DETAIL);
export const FAIL_FETCH_DELIVERY_STATUS_DETAIL = 'FAIL_FETCH_DELIVERY_STATUS_DETAIL';
export const failFetchDeliveryStatusDetail = createAction(FAIL_FETCH_DELIVERY_STATUS_DETAIL);
export const SET_DELIVERY_STATUS_DETAIL_DATA = 'SET_DELIVERY_STATUS_DETAIL_DATA';
export const setDeliveryStatusDetailData = createAction(SET_DELIVERY_STATUS_DETAIL_DATA);
export const RESET_DELIVERY_STATUS_DETAIL_STATE = 'RESET_DELIVERY_STATUS_DETAIL_STATE';
export const resetDeliveryStatusDetailState = createAction(RESET_DELIVERY_STATUS_DETAIL_STATE);


export const GET_PDF_ITEMS_DELIVERY_STATUS_MOD = 'GET_PDF_ITEMS_DELIVERY_STATUS_MOD';
export const getPdfItemsDeliveryStatusMod = createAction(GET_PDF_ITEMS_DELIVERY_STATUS_MOD);
export const FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_MOD = 'FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_MOD';
export const failGetPdfItemsDeliveryStatusMod = createAction(FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_MOD);
export const SET_PDF_ITEMS_DELIVERY_STATUS_MOD = 'SET_PDF_ITEMS_DELIVERY_STATUS_MOD';
export const setPdfItemsDeliveryStatusMod = createAction(SET_PDF_ITEMS_DELIVERY_STATUS_MOD);
export const CLEAR_PDF_ITEMS_DELIVERY_STATUS_MOD = 'CLEAR_PDF_ITEMS_DELIVERY_STATUS_MOD';
export const clearPdfItemsDeliveryStatusMod = createAction(CLEAR_PDF_ITEMS_DELIVERY_STATUS_MOD);

export const GET_PDF_ITEMS_DELIVERY_STATUS_SECOM = 'GET_PDF_ITEMS_DELIVERY_STATUS_SECOM';
export const getPdfItemsDeliveryStatusSecom = createAction(GET_PDF_ITEMS_DELIVERY_STATUS_SECOM);
export const FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_SECOM = 'FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_SECOM';
export const failGetPdfItemsDeliveryStatusSecom = createAction(FAIL_GET_PDF_ITEMS_DELIVERY_STATUS_SECOM);
export const SET_PDF_ITEMS_DELIVERY_STATUS_SECOM = 'SET_PDF_ITEMS_DELIVERY_STATUS_SECOM';
export const setPdfItemsDeliveryStatusSecom = createAction(SET_PDF_ITEMS_DELIVERY_STATUS_SECOM);
export const CLEAR_PDF_ITEMS_DELIVERY_STATUS_SECOM = 'CLEAR_PDF_ITEMS_DELIVERY_STATUS_SECOM';
export const clearPdfItemsDeliveryStatusSecom = createAction(CLEAR_PDF_ITEMS_DELIVERY_STATUS_SECOM);


/*MAPPING*/
export const SET_MAPPING_STATUS = 'SET_MAPPING_STATUS';
export const setMappingStatus = createAction(SET_MAPPING_STATUS);
export const RESET_MAPPING_STATUS = 'RESET_MAPPING_STATUS';
export const resetMappingStatus = createAction(RESET_MAPPING_STATUS);

export const FETCH_MAPPING_INFO = 'FETCH_MAPPING_INFO';
export const fetchMappingInfo = createAction(FETCH_MAPPING_INFO);
export const FAIL_FETCH_MAPPING_INFO = 'FAIL_FETCH_MAPPING_INFO';
export const failFetchMappingInfo = createAction(FAIL_FETCH_MAPPING_INFO);
export const SUCCESS_FETCH_MAPPING_INFO = 'SUCCESS_FETCH_MAPPING_INFO';
export const successFetchMappingInfo = createAction(SUCCESS_FETCH_MAPPING_INFO);

export const SET_MAPPING_INFO = 'SET_MAPPING_INFO';
export const setMappingInfo = createAction(SET_MAPPING_INFO);
export const FAIL_SET_MAPPING_INFO = 'FAIL_SET_MAPPING_INFO';
export const failSetMappingInfo = createAction(FAIL_SET_MAPPING_INFO);
export const SUCCESS_SET_MAPPING_INFO = 'SUCCESS_SET_MAPPING_INFO';
export const successSetMappingInfo = createAction(SUCCESS_SET_MAPPING_INFO);


export const DEL_MAPPING_INFO = 'DEL_MAPPING_INFO';
export const delMappingInfo = createAction(DEL_MAPPING_INFO);
export const FAIL_DEL_MAPPING_INFO = 'FAIL_DEL_MAPPING_INFO';
export const failDelMappingInfo = createAction(FAIL_DEL_MAPPING_INFO);
export const SUCCESS_DEL_MAPPING_INFO = 'SUCCESS_DEL_MAPPING_INFO';
export const successDelMappingInfo = createAction(SUCCESS_DEL_MAPPING_INFO);


/*MASTER COMMON*/
export const GET_USER_LIST = 'GET_USER_LIST';
export const getUserList = createAction(GET_USER_LIST);
export const FAIL_GET_USER_LIST = 'FAIL_GET_USER_LIST';
export const failGetUserList = createAction(FAIL_GET_USER_LIST);
export const SUCCESS_GET_USER_LIST = 'SUCCESS_GET_USER_LIST';
export const successGetUserList = createAction(SUCCESS_GET_USER_LIST);

export const GET_JIGYOSHA_LIST = 'GET_JIGYOSHA_LIST';
export const getJigyoshaList = createAction(GET_JIGYOSHA_LIST);
export const FAIL_GET_JIGYOSHA_LIST = 'FAIL_GET_JIGYOSHA_LIST';
export const failGetJigyoshaList = createAction(FAIL_GET_JIGYOSHA_LIST);
export const SUCCESS_GET_JIGYOSHA_LIST = 'SUCCESS_GET_JIGYOSHA_LIST';
export const successGetJigyoshaList = createAction(SUCCESS_GET_JIGYOSHA_LIST);

export const GET_DENPYO_YOSHIKI_LIST = 'GET_DENPYO_YOSHIKI_LIST';
export const getDenpyoYoshikiList = createAction(GET_DENPYO_YOSHIKI_LIST);
export const FAIL_GET_DENPYO_YOSHIKI_LIST = 'FAIL_GET_DENPYO_YOSHIKI_LIST';
export const failGetDenpyoYoshikiList = createAction(FAIL_GET_DENPYO_YOSHIKI_LIST);
export const SUCCESS_GET_DENPYO_YOSHIKI_LIST = 'SUCCESS_GET_DENPYO_YOSHIKI_LIST';
export const successGetDenpyoYoshikiList = createAction(SUCCESS_GET_DENPYO_YOSHIKI_LIST);

export const GET_KEIYAKU_KIGYOU_LIST = 'GET_KEIYAKU_KIGYOU_LIST';
export const getKeiyakuKigyouList = createAction(GET_KEIYAKU_KIGYOU_LIST);
export const FAIL_GET_KEIYAKU_KIGYOU_LIST = 'FAIL_GET_KEIYAKU_KIGYOU_LIST';
export const failGetKeiyakuKigyouList = createAction(FAIL_GET_KEIYAKU_KIGYOU_LIST);
export const SUCCESS_GET_KEIYAKU_KIGYOU_LIST = 'SUCCESS_GET_KEIYAKU_KIGYOU_LIST';
export const successGetKeiyakuKigyouList = createAction(SUCCESS_GET_KEIYAKU_KIGYOU_LIST);

export const GET_ASN_CORPORATE_LIST = 'GET_ASN_CORPORATE_LIST';
export const getAsnCorporateList = createAction(GET_ASN_CORPORATE_LIST);
export const FAIL_GET_ASN_CORPORATE_LIST = 'FAIL_GET_ASN_CORPORATE_LIST';
export const failGetAsnCorporateList = createAction(FAIL_GET_ASN_CORPORATE_LIST);
export const SUCCESS_GET_ASN_CORPORATE_LIST = 'SUCCESS_GET_ASN_CORPORATE_LIST';
export const successGetAsnCorporateList = createAction(SUCCESS_GET_ASN_CORPORATE_LIST);

export const GET_ASN_RENKEI_LIST = 'GET_ASN_RENKEI_LIST';
export const getASNRenkeiList = createAction(GET_ASN_RENKEI_LIST);
export const FAIL_GET_ASN_RENKEI_LIST = 'FAIL_GET_ASN_RENKEI_LIST';
export const failGetASNRenkeiList = createAction(FAIL_GET_ASN_RENKEI_LIST);
export const SUCCESS_GET_ASN_RENKEI_LIST = 'SUCCESS_GET_ASN_RENKEI_LIST';
export const successGetASNRenkeiList = createAction(SUCCESS_GET_ASN_RENKEI_LIST);

export const UPDATE_MASTER_FLAG = 'UPDATE_MASTER_FLAG';
export const updateMasterFlag = createAction(UPDATE_MASTER_FLAG);

/*USER*/
export const SET_USER_LIST = 'SET_USER_LIST';
export const setUserList = createAction(SET_USER_LIST);
export const FAIL_SET_USER_LIST = 'FAIL_SET_USER_LIST';
export const failSetUserList = createAction(FAIL_SET_USER_LIST);
export const SUCCESS_SET_USER_LIST = 'SUCCESS_SET_USER_LIST';
export const successSetUserList = createAction(SUCCESS_SET_USER_LIST);
export const RESET_MASTER_USERS = 'RESET_MASTER_USERS';
export const resetMasterUsers = createAction(RESET_MASTER_USERS);

export const FETCH_CSV_MASTER_USER = 'FETCH_CSV_MASTER_USER';
export const fetchCsvMasterUser = createAction(FETCH_CSV_MASTER_USER);
export const FAIL_FETCH_CSV_MASTER_USER = 'FAIL_FETCH_CSV_MASTER_USER';
export const failFetchCsvMasterUser = createAction(FAIL_FETCH_CSV_MASTER_USER);
export const SET_CSV_MASTER_USER = 'SET_CSV_MASTER_USER';
export const setCsvMasterUser = createAction(SET_CSV_MASTER_USER);


export const GET_USER_QR_PDF = 'GET_USER_QR_PDF'
export const getUserQrPdf = createAction(GET_USER_QR_PDF);
export const FAIL_GET_USER_QR_PDF = 'FAIL_GET_USER_QR_PDF'
export const failGetUserQrPdf = createAction(FAIL_GET_USER_QR_PDF);
export const SUCCESS_GET_USER_QR_PDF = 'SUCCESS_GET_USER_QR_PDF'
export const successGetUserQrPdf = createAction(SUCCESS_GET_USER_QR_PDF);
export const CLEAR_GET_USER_QR_PDF = 'CLEAR_GET_USER_QR_PDF'
export const clearGetUserQrPdf = createAction(CLEAR_GET_USER_QR_PDF);

/*Nayose*/
export const GET_NAYOSE_LIST = 'GET_NAYOSE_LIST';
export const getNayoseList = createAction(GET_NAYOSE_LIST);
export const FAIL_GET_NAYOSE_LIST = 'FAIL_GET_NAYOSE_LIST';
export const failGetNayoseList = createAction(FAIL_GET_NAYOSE_LIST);
export const SUCCESS_GET_NAYOSE_LIST = 'SUCCESS_GET_NAYOSE_LIST';
export const successGetNayoseList = createAction(SUCCESS_GET_NAYOSE_LIST);

export const SET_NAYOSE_LIST = 'SET_NAYOSE_LIST';
export const setNayoseList = createAction(SET_NAYOSE_LIST);
export const FAIL_SET_NAYOSE_LIST = 'FAIL_SET_NAYOSE_LIST';
export const failSetNayoseList = createAction(FAIL_SET_NAYOSE_LIST);
export const SUCCESS_SET_NAYOSE_LIST = 'SUCCESS_SET_NAYOSE_LIST';
export const successSetNayoseList = createAction(SUCCESS_SET_NAYOSE_LIST);
export const RESET_MASTER_NAYOSE = 'RESET_MASTER_NAYOSE';
export const resetMasterNayose = createAction(RESET_MASTER_NAYOSE);

export const FETCH_CSV_MASTER_NAYOSE = 'FETCH_CSV_MASTER_NAYOSE';
export const fetchCsvMasterNayose = createAction(FETCH_CSV_MASTER_NAYOSE);
export const FAIL_FETCH_CSV_MASTER_NAYOSE = 'FAIL_FETCH_CSV_MASTER_NAYOSE';
export const failFetchCsvMasterNayose = createAction(FAIL_FETCH_CSV_MASTER_NAYOSE);
export const SET_CSV_MASTER_NAYOSE = 'SET_CSV_MASTER_NAYOSE';
export const setCsvMasterNayose = createAction(SET_CSV_MASTER_NAYOSE);


/*secom-signature*/
export const GET_SECOM_SIGNATURE_LIST = 'GET_SECOM_SIGNATURE_LIST';
export const getSecomSignatureList = createAction(GET_SECOM_SIGNATURE_LIST);
export const FAIL_GET_SECOM_SIGNATURE_LIST = 'FAIL_GET_SECOM_SIGNATURE_LIST';
export const failGetSecomSignatureList = createAction(FAIL_GET_SECOM_SIGNATURE_LIST);
export const SUCCESS_GET_SECOM_SIGNATURE_LIST = 'SUCCESS_GET_SECOM_SIGNATURE_LIST';
export const successGetSecomSignatureList = createAction(SUCCESS_GET_SECOM_SIGNATURE_LIST);

export const SET_SECOM_SIGNATURE_LIST = 'SET_SECOM_SIGNATURE_LIST';
export const setSecomSignatureList = createAction(SET_SECOM_SIGNATURE_LIST);
export const FAIL_SET_SECOM_SIGNATURE_LIST = 'FAIL_SET_SECOM_SIGNATURE_LIST';
export const failSetSecomSignatureList = createAction(FAIL_SET_SECOM_SIGNATURE_LIST);
export const SUCCESS_SET_SECOM_SIGNATURE_LIST = 'SUCCESS_SET_SECOM_SIGNATURE_LIST';
export const successSetSecomSignatureList = createAction(SUCCESS_SET_SECOM_SIGNATURE_LIST);
export const RESET_MASTER_SECOM_SIGNATURE = 'RESET_MASTER_SECOM_SIGNATURE'
export const resetMasterSecomSignature = createAction(RESET_MASTER_SECOM_SIGNATURE);

export const FETCH_CSV_MASTER_SECOM_SIGNATURE = 'FETCH_CSV_MASTER_SECOM_SIGNATURE';
export const fetchCsvMasterSecomSignature = createAction(FETCH_CSV_MASTER_SECOM_SIGNATURE);
export const FAIL_FETCH_CSV_MASTER_SECOM_SIGNATURE = 'FAIL_FETCH_CSV_MASTER_SECOM_SIGNATURE';
export const failFetchCsvMasterSecomSignature = createAction(FAIL_FETCH_CSV_MASTER_SECOM_SIGNATURE);
export const SET_CSV_MASTER_SECOM_SIGNATURE = 'SET_CSV_MASTER_SECOM_SIGNATURE';
export const setCsvMasterSecomSignature = createAction(SET_CSV_MASTER_SECOM_SIGNATURE);


/*ReceiptsReferences*/
export const GET_RECEIPTS_REFERENCES_LIST = 'GET_RECEIPTS_REFERENCES_LIST';
export const getReceiptsReferencesList = createAction(GET_RECEIPTS_REFERENCES_LIST);
export const FAIL_GET_RECEIPTS_REFERENCES_LIST = 'FAIL_GET_RECEIPTS_REFERENCES_LIST';
export const failGetReceiptsReferencesList = createAction(FAIL_GET_RECEIPTS_REFERENCES_LIST);
export const SUCCESS_GET_RECEIPTS_REFERENCES_LIST = 'SUCCESS_GET_RECEIPTS_REFERENCES_LIST';
export const successGetReceiptsReferencesList = createAction(SUCCESS_GET_RECEIPTS_REFERENCES_LIST);

export const SET_RECEIPTS_REFERENCES_LIST = 'SET_RECEIPTS_REFERENCES_LIST';
export const setReceiptsReferencesList = createAction(SET_RECEIPTS_REFERENCES_LIST);
export const FAIL_SET_RECEIPTS_REFERENCES_LIST = 'FAIL_SET_RECEIPTS_REFERENCES_LIST';
export const failSetReceiptsReferencesList = createAction(FAIL_SET_RECEIPTS_REFERENCES_LIST);
export const SUCCESS_SET_RECEIPTS_REFERENCES_LIST = 'SUCCESS_SET_RECEIPTS_REFERENCES_LIST';
export const successSetReceiptsReferencesList = createAction(SUCCESS_SET_RECEIPTS_REFERENCES_LIST);
export const RESET_MASTER_RECEIPTS_REFERENCES = 'RESET_MASTER_RECEIPTS_REFERENCES';
export const resetMasterReceiptsReferences = createAction(RESET_MASTER_RECEIPTS_REFERENCES);

export const FETCH_CSV_MASTER_RECEIPTS_REFERENCES = 'FETCH_CSV_MASTER_RECEIPTS_REFERENCES';
export const fetchCsvMasterReceiptsReferences = createAction(FETCH_CSV_MASTER_RECEIPTS_REFERENCES);
export const FAIL_FETCH_CSV_MASTER_RECEIPTS_REFERENCES = 'FAIL_FETCH_CSV_MASTER_RECEIPTS_REFERENCES';
export const failFetchCsvMasterReceiptsReferences = createAction(FAIL_FETCH_CSV_MASTER_RECEIPTS_REFERENCES);
export const SET_CSV_MASTER_RECEIPTS_REFERENCES = 'SET_CSV_MASTER_RECEIPTS_REFERENCES';
export const setCsvMasterReceiptsReferences = createAction(SET_CSV_MASTER_RECEIPTS_REFERENCES);


/*ADD USER*/
export const GET_USER_DATA = 'GET_USER_DATA';
export const getUserData = createAction(GET_USER_DATA);
export const FAIL_GET_USER_DATA = 'FAIL_GET_USER_DATA';
export const failGetUserData = createAction(FAIL_GET_USER_DATA);
export const SUCCESS_GET_USER_DATA = 'SUCCESS_GET_USER_DATA';
export const successGetUserData = createAction(SUCCESS_GET_USER_DATA);

export const SET_USER_DATA = 'SET_USER_DATA';
export const setUserData = createAction(SET_USER_DATA);
export const FAIL_SET_USER_DATA = 'FAIL_SET_USER_DATA';
export const failSetUserData = createAction(FAIL_SET_USER_DATA);
export const SUCCESS_SET_USER_DATA = 'SUCCESS_SET_USER_DATA';
export const successSetUserData = createAction(SUCCESS_SET_USER_DATA);


/*JIGYOUSHA*/
export const GET_JIGYOSHA_LIST_WD = 'GET_JIGYOSHA_LIST_WD';
export const getJigyoshaListWD = createAction(GET_JIGYOSHA_LIST_WD);
export const FAIL_GET_JIGYOSHA_LIST_WD = 'FAIL_GET_JIGYOSHA_LIST_WD';
export const failGetJigyoshaListWD = createAction(FAIL_GET_JIGYOSHA_LIST_WD);
export const SUCCESS_GET_JIGYOSHA_LIST_WD = 'SUCCESS_GET_JIGYOSHA_LIST_WD';
export const successGetJigyoshaListWD = createAction(SUCCESS_GET_JIGYOSHA_LIST_WD);

export const GET_JIGYOSHA = 'GET_JIGYOSHA';
export const getJigyosha = createAction(GET_JIGYOSHA);
export const FAIL_GET_JIGYOSHA = 'FAIL_GET_JIGYOSHA';
export const failGetJigyosha = createAction(FAIL_GET_JIGYOSHA);
export const SUCCESS_GET_JIGYOSHA = 'SUCCESS_GET_JIGYOSHA';
export const successGetJigyosha = createAction(SUCCESS_GET_JIGYOSHA);

export const SET_JIGYOSHA = 'SET_JIGYOSHA';
export const setJigyosha = createAction(SET_JIGYOSHA);
export const FAIL_SET_JIGYOSHA = 'FAIL_SET_JIGYOSHA';
export const failSetJigyosha = createAction(FAIL_SET_JIGYOSHA);
export const SUCCESS_SET_JIGYOSHA = 'SUCCESS_SET_JIGYOSHA';
export const successSetJigyosha = createAction(SUCCESS_SET_JIGYOSHA);

export const DEL_JIGYOSHA = 'DEL_JIGYOSHA';
export const delJigyosha = createAction(DEL_JIGYOSHA);
export const FAIL_DEL_JIGYOSHA = 'FAIL_DEL_JIGYOSHA';
export const failDelJigyosha = createAction(FAIL_DEL_JIGYOSHA);
export const SUCCESS_DEL_JIGYOSHA = 'SUCCESS_DEL_JIGYOSHA';
export const successDelJigyosha = createAction(SUCCESS_DEL_JIGYOSHA);

export const RESTORE_JIGYOSHA = 'RESTORE_JIGYOSHA';
export const restoreJigyosha = createAction(RESTORE_JIGYOSHA);
export const FAIL_RESTORE_JIGYOSHA = 'FAIL_RESTORE_JIGYOSHA';
export const failRestoreJigyosha = createAction(FAIL_RESTORE_JIGYOSHA);
export const SUCCESS_RESTORE_JIGYOSHA = 'SUCCESS_RESTORE_JIGYOSHA';
export const successRestoreJigyosha = createAction(SUCCESS_RESTORE_JIGYOSHA);

export const CLEAR_JIGYOUSHA = 'CLEAR_JIGYOUSHA';
export const clearJigyousha = createAction(CLEAR_JIGYOUSHA);
export const RESET_MASTER_JIGYOUSHA = 'RESET_MASTER_JIGYOUSHA';
export const resetMasterJigyousha = createAction(RESET_MASTER_JIGYOUSHA);

export const GET_BUTSURYU_BOTEN = 'GET_BUTSURYU_BOTEN';
export const getButsuryuBoten = createAction(GET_BUTSURYU_BOTEN);
export const FAIL_GET_BUTSURYU_BOTEN = 'FAIL_GET_BUTSURYU_BOTEN';
export const failGetButsuryuBoten = createAction(FAIL_GET_BUTSURYU_BOTEN);
export const SUCCESS_GET_BUTSURYU_BOTEN = 'SUCCESS_GET_BUTSURYU_BOTEN';
export const successGetButsuryuBoten = createAction(SUCCESS_GET_BUTSURYU_BOTEN);

export const GET_MAKER = 'GET_MAKER';
export const getMaker = createAction(GET_MAKER);
export const FAIL_GET_MAKER = 'FAIL_GET_MAKER';
export const failGetMaker = createAction(FAIL_GET_MAKER);
export const SUCCESS_GET_MAKER = 'SUCCESS_GET_MAKER';
export const successGetMaker = createAction(SUCCESS_GET_MAKER);

/*KEIYAKUKIGYOU*/
export const GET_KEIYAKU_KIGYOU_LIST_WD = 'GET_KEIYAKU_KIGYOU_LIST_WD';
export const getKeiyakuKigyouListWD = createAction(GET_KEIYAKU_KIGYOU_LIST_WD);
export const FAIL_GET_KEIYAKU_KIGYOU_LIST_WD = 'FAIL_GET_KEIYAKU_KIGYOU_LIST_WD';
export const failGetKeiyakuKigyouListWD = createAction(FAIL_GET_KEIYAKU_KIGYOU_LIST_WD);
export const SUCCESS_GET_KEIYAKU_KIGYOU_LIST_WD = 'SUCCESS_GET_KEIYAKU_KIGYOU_LIST_WD';
export const successGetKeiyakuKigyouListWD = createAction(SUCCESS_GET_KEIYAKU_KIGYOU_LIST_WD);

export const GET_KEIYAKU_KIGYOU = 'GET_KEIYAKU_KIGYOU';
export const getKeiyakuKigyou = createAction(GET_KEIYAKU_KIGYOU);
export const FAIL_GET_KEIYAKU_KIGYOU = 'FAIL_GET_KEIYAKU_KIGYOU';
export const failGetKeiyakuKigyou = createAction(FAIL_GET_KEIYAKU_KIGYOU);
export const SUCCESS_GET_KEIYAKU_KIGYOU = 'SUCCESS_GET_KEIYAKU_KIGYOU';
export const successGetKeiyakuKigyou = createAction(SUCCESS_GET_KEIYAKU_KIGYOU);

export const SET_KEIYAKU_KIGYOU = 'SET_KEIYAKU_KIGYOU';
export const setKeiyakuKigyou = createAction(SET_KEIYAKU_KIGYOU);
export const FAIL_SET_KEIYAKU_KIGYOU = 'FAIL_SET_KEIYAKU_KIGYOU';
export const failSetKeiyakuKigyou = createAction(FAIL_SET_KEIYAKU_KIGYOU);
export const SUCCESS_SET_KEIYAKU_KIGYOU = 'SUCCESS_SET_KEIYAKU_KIGYOU';
export const successSetKeiyakuKigyou = createAction(SUCCESS_SET_KEIYAKU_KIGYOU);

export const DEL_KEIYAKU_KIGYOU = 'DEL_KEIYAKU_KIGYOU';
export const delKeiyakuKigyou = createAction(DEL_KEIYAKU_KIGYOU);
export const FAIL_DEL_KEIYAKU_KIGYOU = 'FAIL_DEL_KEIYAKU_KIGYOU';
export const failDelKeiyakuKigyou = createAction(FAIL_DEL_KEIYAKU_KIGYOU);
export const SUCCESS_DEL_KEIYAKU_KIGYOU = 'SUCCESS_DEL_KEIYAKU_KIGYOU';
export const successDelKeiyakuKigyou = createAction(SUCCESS_DEL_KEIYAKU_KIGYOU);

export const RESTORE_KEIYAKU_KIGYOU = 'RESTORE_KEIYAKU_KIGYOU';
export const restoreKeiyakuKigyou = createAction(RESTORE_KEIYAKU_KIGYOU);
export const FAIL_RESTORE_KEIYAKU_KIGYOU = 'FAIL_RESTORE_KEIYAKU_KIGYOU';
export const failRestoreKeiyakuKigyou = createAction(FAIL_RESTORE_KEIYAKU_KIGYOU);
export const SUCCESS_RESTORE_KEIYAKU_KIGYOU = 'SUCCESS_RESTORE_KEIYAKU_KIGYOU';
export const successRestoreKeiyakuKigyou = createAction(SUCCESS_RESTORE_KEIYAKU_KIGYOU);

export const CLEAR_KEIYAKU_KIGYOU = 'CLEAR_KEIYAKU_KIGYOU';
export const clearKeiyakuKigyou = createAction(CLEAR_KEIYAKU_KIGYOU);

//ASN CORPORATE MANAGEMENT
export const SET_ASN_CORPORATE_LIST = 'SET_ASN_CORPORATE_LIST';
export const setAsnCorporateList = createAction(SET_ASN_CORPORATE_LIST);
export const SUCCESS_SET_ASN_CORPORATE_LIST = 'SUCCESS_SET_ASN_CORPORATE_LIST';
export const successSetAsnCorporateList = createAction(SUCCESS_SET_ASN_CORPORATE_LIST);
export const FAIL_SET_ASN_CORPORATE_LIST = 'FAIL_SET_ASN_CORPORATE_LIST';
export const failSetAsnCorporateList = createAction(FAIL_SET_ASN_CORPORATE_LIST);
export const FETCH_CSV_MASTER_ASN_CORPORATE = 'FETCH_CSV_MASTER_ASN_CORPORATE';
export const fetchCsvMasterAsnCorporate = createAction(FETCH_CSV_MASTER_ASN_CORPORATE);
export const FAIL_FETCH_CSV_MASTER_ASN_CORPORATE = 'FAIL_FETCH_CSV_MASTER_ASN_CORPORATE';
export const failFetchCsvMasterAsnCorporate = createAction(FAIL_FETCH_CSV_MASTER_ASN_CORPORATE);
export const SET_CSV_MASTER_ASN_CORPORATE = 'SET_CSV_MASTER_ASN_CORPORATE';
export const setCsvMasterAsnCorporate = createAction(SET_CSV_MASTER_ASN_CORPORATE);
export const RESET_MASTER_ASN_CORPORATE = 'RESET_MASTER_ASN_CORPORATE';
export const resetMasterAsnCorporate = createAction(RESET_MASTER_ASN_CORPORATE);
export const GET_TR_HENKAN_LIST = 'GET_TR_HENKAN_LIST';
export const getTrHenkanList = createAction(GET_TR_HENKAN_LIST);
export const FAIL_GET_TR_HENKAN_LIST = 'FAIL_GET_TR_HENKAN_LIST';
export const failGetTrHenkanList = createAction(FAIL_GET_TR_HENKAN_LIST);
export const SUCCESS_GET_TR_HENKAN_LIST = 'SUCCESS_GET_TR_HENKAN_LIST';
export const successGetTrHenkanList = createAction(SUCCESS_GET_TR_HENKAN_LIST);

export const SET_TR_HENKAN_LIST = 'SET_TR_HENKAN_LIST';
export const setTrHenkanList = createAction(SET_TR_HENKAN_LIST);
export const FAIL_SET_TR_HENKAN_LIST = 'FAIL_SET_TR_HENKAN_LIST';
export const failSetTrHenkanList = createAction(FAIL_SET_TR_HENKAN_LIST);
export const SUCCESS_SET_TR_HENKAN_LIST = 'SUCCESS_SET_TR_HENKAN_LIST';
export const successSetTrHenkanList = createAction(SUCCESS_SET_TR_HENKAN_LIST);
export const RESET_MASTER_TR_HENKAN = 'RESET_MASTER_TR_HENKAN';
export const resetMasterTrHenkan = createAction(RESET_MASTER_TR_HENKAN);

export const FETCH_CSV_MASTER_TR_HENKAN = 'FETCH_CSV_MASTER_TR_HENKAN';
export const fetchCsvMasterTrHenkan = createAction(FETCH_CSV_MASTER_TR_HENKAN);
export const FAIL_FETCH_CSV_MASTER_TR_HENKAN = 'FAIL_FETCH_CSV_MASTER_TR_HENKAN';
export const failFetchCsvMasterTrHenkan = createAction(FAIL_FETCH_CSV_MASTER_TR_HENKAN);
export const SET_CSV_MASTER_TR_HENKAN = 'SET_CSV_MASTER_TR_HENKAN';
export const setCsvMasterTrHenkan = createAction(SET_CSV_MASTER_TR_HENKAN);
export const GET_ASN_HENKAN_LIST = 'GET_ASN_HENKAN_LIST';
export const getAsnHenkanList = createAction(GET_ASN_HENKAN_LIST);
export const FAIL_GET_ASN_HENKAN_LIST = 'FAIL_GET_ASN_HENKAN_LIST';
export const failGetAsnHenkanList = createAction(FAIL_GET_ASN_HENKAN_LIST);
export const SUCCESS_GET_ASN_HENKAN_LIST = 'SUCCESS_GET_ASN_HENKAN_LIST';
export const successGetAsnHenkanList = createAction(SUCCESS_GET_ASN_HENKAN_LIST);

export const SET_ASN_HENKAN_LIST = 'SET_ASN_HENKAN_LIST';
export const setAsnHenkanList = createAction(SET_ASN_HENKAN_LIST);
export const FAIL_SET_ASN_HENKAN_LIST = 'FAIL_SET_ASN_HENKAN_LIST';
export const failSetAsnHenkanList = createAction(FAIL_SET_ASN_HENKAN_LIST);
export const SUCCESS_SET_ASN_HENKAN_LIST = 'SUCCESS_SET_ASN_HENKAN_LIST';
export const successSetAsnHenkanList = createAction(SUCCESS_SET_ASN_HENKAN_LIST);
export const RESET_MASTER_ASN_HENKAN = 'RESET_MASTER_ASN_HENKAN';
export const resetMasterAsnHenkan = createAction(RESET_MASTER_ASN_HENKAN);

export const GET_ASN_LIST = 'GET_ASN_LIST';
export const getAsnList = createAction(GET_ASN_LIST);
export const FAIL_GET_ASN_LIST = 'FAIL_GET_ASN_LIST';
export const failGetAsnList = createAction(FAIL_GET_ASN_LIST);
export const SUCCESS_GET_ASN_LIST = 'SUCCESS_GET_ASN_LIST';
export const successGetAsnList = createAction(SUCCESS_GET_ASN_LIST);

export const FETCH_CSV_MASTER_ASN_HENKAN = 'FETCH_CSV_MASTER_ASN_HENKAN';
export const fetchCsvMasterAsnHenkan = createAction(FETCH_CSV_MASTER_ASN_HENKAN);
export const FAIL_FETCH_CSV_MASTER_ASN_HENKAN = 'FAIL_FETCH_CSV_MASTER_ASN_HENKAN';
export const failFetchCsvMasterAsnHenkan = createAction(FAIL_FETCH_CSV_MASTER_ASN_HENKAN);
export const SET_CSV_MASTER_ASN_HENKAN = 'SET_CSV_MASTER_ASN_HENKAN';
export const setCsvMasterAsnHenkan = createAction(SET_CSV_MASTER_ASN_HENKAN);

/*HasonhoukokuKbn*/
export const GET_HASONHOUKOKU_KBN_LIST = 'GET_HASONHOUKOKU_KBN_LIST';
export const getHasonhoukokuKbnList = createAction(GET_HASONHOUKOKU_KBN_LIST);
export const FAIL_GET_HASONHOUKOKU_KBN_LIST = 'FAIL_GET_HASONHOUKOKU_KBN_LIST';
export const failGetHasonhoukokuKbnList = createAction(FAIL_GET_HASONHOUKOKU_KBN_LIST);
export const SUCCESS_GET_HASONHOUKOKU_KBN_LIST = 'SUCCESS_GET_HASONHOUKOKU_KBN_LIST';
export const successGetHasonhoukokuKbnList = createAction(SUCCESS_GET_HASONHOUKOKU_KBN_LIST);

export const SET_HASONHOUKOKU_KBN_LIST = 'SET_HASONHOUKOKU_KBN_LIST';
export const setHasonhoukokuKbnList = createAction(SET_HASONHOUKOKU_KBN_LIST);
export const FAIL_SET_HASONHOUKOKU_KBN_LIST = 'FAIL_SET_HASONHOUKOKU_KBN_LIST';
export const failSetHasonhoukokuKbnList = createAction(FAIL_SET_HASONHOUKOKU_KBN_LIST);
export const SUCCESS_SET_HASONHOUKOKU_KBN_LIST = 'SUCCESS_SET_HASONHOUKOKU_KBN_LIST';
export const successSetHasonhoukokuKbnList = createAction(SUCCESS_SET_HASONHOUKOKU_KBN_LIST);
export const RESET_MASTER_HASONHOUKOKU_KBN = 'RESET_MASTER_HASONHOUKOKU_KBN';
export const resetMasterHasonhoukokuKbn = createAction(RESET_MASTER_HASONHOUKOKU_KBN);

export const FETCH_CSV_MASTER_HASONHOUKOKU_KBN = 'FETCH_CSV_MASTER_HASONHOUKOKU_KBN';
export const fetchCsvMasterHasonhoukokuKbn = createAction(FETCH_CSV_MASTER_HASONHOUKOKU_KBN);
export const FAIL_FETCH_CSV_MASTER_HASONHOUKOKU_KBN = 'FAIL_FETCH_CSV_MASTER_HASONHOUKOKU_KBN';
export const failFetchCsvMasterHasonhoukokuKbn = createAction(FAIL_FETCH_CSV_MASTER_HASONHOUKOKU_KBN);
export const SET_CSV_MASTER_HASONHOUKOKU_KBN = 'SET_CSV_MASTER_HASONHOUKOKU_KBN';
export const setCsvMasterHasonhoukokuKbn = createAction(SET_CSV_MASTER_HASONHOUKOKU_KBN);



// WEBPACK FOOTER //
// ./src/actions/index.js